import { Bulk as BulkMessagingService } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { bindHTTP } from '@frontend/schema';

export const SchemaBulkMessagingService = bindHTTP(BulkMessagingService);
